module.exports = "/_next/static/images/video_id_7103928003352120619-1bf9611f59b641c1bdefb8291313f09f.jpg";